import {useEffect, useState} from "react";


function sizeHandler() {
    const winW = window.innerWidth;
    const winH = window.innerHeight;
    return {
        winW,
        winH
    };
}

function scrollHandler() {
    return window.scrollY
}

function setItem(key,result) {
    localStorage.setItem(key,JSON.stringify(result))
}


const useSizeCheck = () => {

    const { winW, winH } = JSON.parse(localStorage.getItem('win')) || {};
    const scrollNow = JSON.parse(localStorage.getItem('scrollNow')) || 0;
    const [size, setSize] = useState({
        winW,
        winH,
        scrollNow
    })

    useEffect(() => {

        window.addEventListener('resize', () => {
            const result = sizeHandler();
            setItem('win', result)
            setSize(prev => ({
                ...prev,
                ...result
            }))
        })

        window.addEventListener('scroll', () => {
            const result = scrollHandler();
            setItem('scrollNow',result)
            setSize(prev => ({
                ...prev,
                scrollNow: result
            }))
        })


        return () => {

            window.removeEventListener('resize', () => {
                sizeHandler()
            })

            window.removeEventListener('scroll', () => {
                scrollHandler()
            })
        }
    }, []);

    return size
}

export default useSizeCheck;